export const masterMsg = '操作権限がありません。';

export const authNone = 0;
export const authRef = 1;
export const authEdit = 2;
